import { ResourceType } from '@/enums/ResourceType';
import { INotification } from '@/resources/upgrade/Notification';

// Builds the deep-link a notification row navigates to. Lecture notifications
// point at the lecture/poster; community notifications point at the post.
// The `notificationId` query param lets the destination page mark it read.
export const getNotificationResourceLink = (eventId: string, notification: INotification): string => {
  const { resource_type, resource_id, lecture, community_post, comment, id } = notification;

  if (resource_type === ResourceType.Lecture && lecture) {
    const isPoster = Boolean(lecture.poster_lecture);
    // event_session is relationship linkage only ({ id, type }) — we just need the id
    const sessionId = lecture.event_session?.id;

    return `/events/${eventId}/${isPoster ? 'posters' : 'sessions'}/${sessionId}/${isPoster ? 'poster' : 'lecture'}/${
      lecture.link_slug
    }?notificationId=${id}`;
  }

  if (community_post) {
    const base = `/events/${eventId}/community/${community_post.id}?notificationId=${id}`;

    // The comment to scroll to and flash. Comment/reply/mention notifications
    // put the comment id directly in resource_id. Reaction "liked" notifications
    // put the reaction id in resource_id instead, so they rely on a dedicated
    // `comment` relationship linkage (added by the backend) for the comment id.
    const commentAnchorId = comment?.id ?? (resource_type === ResourceType.Comment ? resource_id : undefined);

    if (commentAnchorId) {
      return `${base}&commentId=${commentAnchorId}`;
    }

    return base;
  }

  return '';
};
